<script>
export default {
  name: "IconInfo"
};
</script>

<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 8.5c0-4.409-3.591-8-8-8s-8 3.591-8 8 3.591 8 8 8 8-3.591 8-8Zm-1.422 0A6.586 6.586 0 0 1 8 15.078 6.586 6.586 0 0 1 1.422 8.5 6.586 6.586 0 0 1 8 1.922 6.586 6.586 0 0 1 14.578 8.5Z"
      fill="currentColor"
    />
    <circle cx="8" cy="4.392" transform="rotate(-180 8 4.392)" fill="currentColor" r=".923" />
    <path
      d="M8 6.402c.391 0 .711.32.711.711v5.867c0 .391-.32.711-.711.711a.713.713 0 0 1-.711-.711V7.113c0-.39.32-.71.711-.71Z"
      fill="currentColor"
    />
  </svg>
</template>
